export const storeNameBrokerAuth = 'authBroker'

export function useAuthBroker(): string | null | undefined {
  const strAuth = sessionStorage.getItem(storeNameBrokerAuth)

  if (!strAuth) return null

  const auth: string = JSON.parse(strAuth)
  return auth
}
